import { render, staticRenderFns } from "./multiTenantAddForm.vue?vue&type=template&id=3e4dc6b8&scoped=true&"
import script from "./multiTenantAddForm.vue?vue&type=script&lang=js&"
export * from "./multiTenantAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4dc6b8",
  null
  
)

export default component.exports